import { useState } from 'react';
import '../../styles/SignInUp.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../ToastContext';

function ForgotPassword() {
    const API_URL = process.env.REACT_APP_API_URL;
    
    const {showToast} = useToast();

    const navigate = useNavigate();

    const [email, setEmail] = useState('');

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (email) {
            try {
                const response = await axios.post(`${API_URL}/users/forgot-password`, { email })

                if (response.data) {
                    navigate('/weryfikacja-email', { state: { email: email } });
                } else {
                    showToast("Wystąpił błąd, spróbuj ponownie", "error")
                }

            } catch (error) {
                if (error.response) {
                    showToast("Wystąpił błąd, spróbuj ponownie", "error")
                } else {
                    showToast("Błąd połączenia z serwerem", "error")
                }
            }
        };
    }

    return (
        <div className="register-wrapper">
            <div className="register-card">
                <h2 className="register-title">
                    TRADI<span className="logo-highlight">WORLD</span>
                </h2>
                <p className="register-subtitle">Aby zresetować hasło podaj swój adres e-mail.</p>

                <form onSubmit={handleResetPassword} method='POST' className="register-form">
                    <div className="input-group">
                        <label htmlFor="email">Adres e-mail</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="twoj@email.com"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="register-button">
                        Wyślij link do resetu hasła
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ForgotPassword;